import SimpleBar from "simplebar";

function throttle(fn, threshhold, scope) {
    var last, deferTimer;
    return function () {
        var now = +new Date;
        if (last && now < last + threshhold) {
            // hold on to it
            clearTimeout(deferTimer);
            deferTimer = setTimeout(function () {
                last = now;
                fn.apply(scope);
            }, threshhold + last - now);
        } else {
            last = now;
            fn.apply(scope);
        }
    };
}


var scrollProgressBar = window.scrollProgressBar  ={
    throttleTime: 50,
    con: null,
    progress: 0,
    bar: null,

    init: function(){
        // var viewportHeight =  document.body.scrollHeight - window.innerHeight;
        this.con = document.querySelector('.news .con');
        this.bar = document.querySelector('.article-progress-bar');
        this.addEvent();
    },

    addEvent: function() {
        this.event = window.addEventListener(
            'scroll',
            throttle(this.check, this.throttleTime, this),
            { passive: true }
        );
    },

    check: function(){
        var scrolled = window.pageYOffset;
        var bottom = this.con.getBoundingClientRect().bottom + scrolled + 50;
        var widowHeight = window.innerHeight;

        var progress = scrolled / (bottom - widowHeight) * 100;
        progress = Math.round(progress*4)/4;
        if(this.progress != progress){
            this.progress = progress;
            this.update();
        }

    },

    update: function(){
        window.requestAnimationFrame(function(){
            this.bar.style.width = this.progress + '%';
        }.bind(this))
    }
}




// WEBPACK FOOTER //
// ./Resources/assets/js/scroll-progress.js